import React from 'react';
import { Box, Flex } from 'pounceV2';
import useRouter from 'Hooks/useRouter';
import useWindowSize from 'Hooks/useWindowSize';
import BreadcrumbsV3 from 'Components/Breadcrumbs/BreadcrumbsV3';
import { useTheme } from '@mui/material';
import NotificationsMenuV3 from './SecondaryMenus/NotificationsMenuV3';
import HelpMenuV3 from './SecondaryMenus/HelpMenuV3';
import { HEADER_HEIGHT } from '../constants';

// Space kept clear from the right-side menus when deciding to truncate breadcrumbs.
const BREADCRUMB_TRUNCATION_PADDING = 16;

const TopNavigationMenuV3 = () => {
  const theme = useTheme();
  const { location } = useRouter();
  const { width } = useWindowSize();
  const wrapperRef = React.useRef(null);
  const breadcrumbRef = React.useRef(null);
  const [truncateBreadcrumbs, setTruncateBreadcrumbs] = React.useState(false);

  React.useEffect(() => {
    if (wrapperRef.current?.offsetWidth && breadcrumbRef.current?.offsetWidth) {
      // truncate breadcrumbs if their width exceeds the space available in the top nav
      const enableTruncation =
        wrapperRef.current.offsetWidth - BREADCRUMB_TRUNCATION_PADDING <
        breadcrumbRef.current.offsetWidth;

      setTruncateBreadcrumbs(enableTruncation);
    }
  }, [
    width,
    location.pathname,
    wrapperRef.current?.offsetWidth,
    breadcrumbRef.current?.offsetWidth,
  ]);

  return (
    <Flex
      as="header"
      width="100%"
      height={HEADER_HEIGHT}
      p={4}
      position="relative"
      minWidth="min-content"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        borderBottom: `1px solid ${theme.palette.componentTokens.navigation.colors.stroke.containerBase}`,
      }}
      backgroundColor={theme.palette.componentTokens.navigation.colors.background.containerBase}
    >
      <Flex ref={wrapperRef} alignItems="center" mr={4} flexGrow={2}>
        <Box ref={breadcrumbRef}>
          <BreadcrumbsV3 truncated={truncateBreadcrumbs} />
        </Box>
      </Flex>
      <Flex
        as="nav"
        aria-label="Top Navigation Menu"
        alignItems="center"
        alignContent="center"
        gap={4}
        data-dd-privacy="mask-user-input"
      >
        <HelpMenuV3 />
        <NotificationsMenuV3 />
      </Flex>
    </Flex>
  );
};

export default React.memo(TopNavigationMenuV3);
